import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";

@Component({
  selector: "medication-list",
  templateUrl: "medication-list.html",
})
export class MedicationListComponent implements OnInit {
  @Input() medications: any[] = [];

  selected: any = null;

  @Output() onSelect: EventEmitter<any> = new EventEmitter();

  constructor() {
    // ASSUMPTION: by default, select the first in the list
  }

  ngOnInit() {
    if (this.medications && this.medications.length > 0) {
      this.select(this.medications[0]);
    }
  }

  select(med) {
    if (this.selected !== med) {
      this.selected = med;
      this.updateItem({ selected: this.selected });
    }
  }

  isSelected(med) {
    return this.selected == med;
  }

  updateItem(event) {
    this.onSelect.emit(event);
  }
}



// WEBPACK FOOTER //
// ./src/components/medication-administration-records/medication-list/medication-list.ts